import React, { useState, useEffect } from "react";
import { Dropdown, Accordion } from "react-bootstrap";
import axios from "axios";
import AddBookingGuests from "../components/AddBookingGuests";
import EditBookingLocation from "../components/EditBookingLocation";
import CancelBookingModal from "../components/CancelBookingModal";
import RequestReschedule from "../components/RequestReschedule";
import Swal from "sweetalert2";
import API_BASE_URL from "../config";
// Set axios default headers
axios.defaults.withCredentials = true; // Ensure credentials are sent with requests
axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem(
  "token"
)}`; // Optionally add token if available
export const showToast = (title, icon = "success") => {
  Swal.fire({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    icon,
    title,
  });
};
const UserBookings = () => {
  const [bookings, setBookings] = useState([]);
  const [filteredBookings, setFilteredBookings] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterStatus, setFilterStatus] = useState("all"); // 'confirmed', 'payment_completed', 'past', 'upcoming'
  const [expandedBookingId, setExpandedBookingId] = useState(null);
  const [showAddGuestsModal, setShowAddGuestsModal] = useState(false);
  const [selectedBookingId, setSelectedBookingId] = useState(null);
  const [showEditLocationModal, setShowEditLocationModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [bookingId, setBookingId] = useState(null);
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);
  const [rescheduleReason, setRescheduleReason] = useState("");
  const [reschedulingBookingId, setReschedulingBookingId] = useState(null);
  const statusCounts = {
    all: bookings.length,
    confirmed: bookings.filter((b) => b.payment_status === "completed").length,
    payment_completed: bookings.filter((b) => b.payment_status === "completed")
      .length,
    past: bookings.filter((b) => new Date(b.booked_at) < new Date()).length,
    upcoming: bookings.filter((b) => new Date(b.booked_at) > new Date()).length,
    active: bookings.filter((b) => Number(b.status) === 1).length,
    request_reschedule: bookings.filter((b) => Number(b.status) === 2).length,
    rescheduled: bookings.filter((b) => Number(b.status) === 3).length,
    cancelled: bookings.filter((b) => Number(b.status) === 4).length,
  };
  useEffect(() => {
    // Fetch user bookings when the component mounts
    const fetchBookings = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/user/bookings`,
          { withCredentials: true }
        );
        // Sort by most recent first (defensive)
        const data = response.data || [];
        const sortedBookings = [...data].sort((a, b) => {
          const dateA = new Date(a?.booked_at || 0);
          const dateB = new Date(b?.booked_at || 0);
          return dateB - dateA;
        });
        setBookings(sortedBookings);
        setFilteredBookings(sortedBookings);
      } catch (error) {
        console.error("Error fetching bookings:", error);
      }
    };

    fetchBookings();
  }, []);

  useEffect(() => {
    const filtered = bookings.filter((booking) => {
      const matchesSearch = (booking.event_title || "")
        .toLowerCase()
        .includes((searchTerm || "").toLowerCase());

      const matchesStatus =
        filterStatus === "all" ||
        (filterStatus === "confirmed" &&
          booking.payment_status === "completed") ||
        (filterStatus === "payment_completed" &&
          booking.payment_status === "completed") ||
        (filterStatus === "past" && new Date(booking.booked_at) < new Date()) ||
        (filterStatus === "upcoming" &&
          new Date(booking.booked_at) > new Date()) ||
        (filterStatus === "active" && Number(booking.status) === 1) ||
        (filterStatus === "request_reschedule" &&
          Number(booking.status) === 2) ||
        (filterStatus === "rescheduled" && Number(booking.status) === 3) ||
        (filterStatus === "cancelled" && Number(booking.status) === 4);

      return matchesSearch && matchesStatus;
    });

    setFilteredBookings(filtered);
  }, [bookings, searchTerm, filterStatus]);

  // Example functions for booking actions
  const handleCancelBooking = (bookingId) => {
    console.log(`Cancel booking with ID: ${bookingId}`);
    setBookingId(bookingId);
    // Implement the cancellation logic here
    setShowModal(true);
  };
  const cancelBooking = async (bookingId) => {
    console.log(`Cancelling booking with ID: ${bookingId}`);
    await axios.post(`${API_BASE_URL}/event/update-booking`, {
      booking_id: bookingId,
      update_type: "status",
      value: 4,
    });
    showToast("Booking cancelled successfully!");
    setShowModal(false); // Close the modal after the cancellation
  };
  // Close the modal without doing anything
  const closeModal = () => {
    setShowModal(false);
  };
  const handleAddGuests = (bookingId) => {
    console.log(`Add Guests to booking with ID: ${bookingId}`);
    setSelectedBookingId(bookingId);
    setShowAddGuestsModal(true);
  };

  // Inside the handleEditLocation function
  const handleEditLocation = (bookingId) => {
    console.log(`Edit location for booking with ID: ${bookingId}`);
    setSelectedBookingId(bookingId);
    setShowEditLocationModal(true);
  };

  const handleRequestReschedule = (bookingId) => {
    console.log(`Request reschedule for booking with ID: ${bookingId}`);
    setReschedulingBookingId(bookingId);
    setShowRescheduleModal(true);
  };
  const handleSubmitReschedule = async () => {
    if (!rescheduleReason.trim()) {
      showToast("Please provide a reason for rescheduling.", "warning");
      return;
    }

    try {
      await axios.post(`${API_BASE_URL}/event/update-booking`, {
        booking_id: reschedulingBookingId,
        update_type: "reschedule_reason",
        value: rescheduleReason,
      });

      showToast("Reschedule request submitted successfully!");
      setShowRescheduleModal(false);
      setRescheduleReason("");
      setReschedulingBookingId(null);
      window.location.reload();
    } catch (error) {
      console.error("Error requesting reschedule:", error);
      showToast("Failed to submit reschedule request.", "error");
    }
  };
  const handleRescheduleBooking = (bookingId, slug) => {
    console.log(`Reschedule booking with ID: ${bookingId}`);
    // Construct the URL with the bookingId and slug as query parameters
    const url = `/events/${slug}?bookingId=${bookingId}`;
    // Open the URL in a new tab
    window.open(url, "_blank");
  };
  const getStatusClass = (status) => {
    switch (Number(status)) {
      case 1: // Active
        return "border-success"; // Green border
      case 2: // Request Reschedule
        return "border-warning"; // Yellow border
      case 3: // Rescheduled
        return "border-primary"; // Blue border
      case 4: // Cancelled
        return "border-danger"; // Red border
      default:
        return "border-secondary"; // Grey border (fallback)
    }
  };
  return (
    <div className="container p-3">
      <div class="d-flex justify-content-between align-items-center mb-4 title-line-re">
        <h5 class="fw700 mb-0 color1">Your Bookings</h5>
      </div>
      <div className="row">
        <div className="col-md-8 col-12">
          {/* Search Bar */}
          <div className="mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Search by event"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
        <div className="col-md-4 col-12">
          {/* Status Filter */}
          <div className="mb-3">
            <select
              className="form-select"
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
            >
              <option value="all">All ({statusCounts.all})</option>
              <option value="confirmed">
                Confirmed ({statusCounts.confirmed})
              </option>
              <option value="payment_completed">
                Payment Completed ({statusCounts.payment_completed})
              </option>
              <option value="past">Past Bookings ({statusCounts.past})</option>
              <option value="upcoming">
                Upcoming Bookings ({statusCounts.upcoming})
              </option>
              <option value="active">Active ({statusCounts.active})</option>
              <option value="request_reschedule">
                Request Reschedule ({statusCounts.request_reschedule})
              </option>
              <option value="rescheduled">
                Rescheduled ({statusCounts.rescheduled})
              </option>
              <option value="cancelled">
                Cancelled ({statusCounts.cancelled})
              </option>
            </select>
          </div>
        </div>
      </div>

      <div className="row">
        {filteredBookings.length === 0 ? (
          <p>No bookings found.</p>
        ) : (
          filteredBookings.map((booking) => (
            <div key={booking.booking_id} className="col-md-4 mb-4">
              <div
                className={`mb-3 ybcard card ${getStatusClass(booking.status)}`}
              >
                <div className="card-body p-0">
                  <div className="p-3 tetbx">
                    <h5 className="card-title mb-0">{booking.event_title}</h5>
                  </div>

                  <div className="p-3">
                    <p className="card-text mb-0 d-flex justify-content-between mb-0">
                      {
                        <div className="mb-2">
                          <span className="color2 c-badge w98">
                            <i class="bi bi-person-fill"></i>{" "}
                          </span>
                          &nbsp; {booking.user_name}
                        </div>
                      }
                      {
                        <div className="mb-2 statsbx">
                          <span className="color2 c-badge">
                            <i className="bi bi-credit-card-fill"></i> Payment
                          </span>{" "}
                          {booking.payment_status ? (
                            booking.payment_status
                          ) : (
                            <span className="nanvalue">_____</span>
                          )}
                          {booking.payment_status === "completed" && (
                            <p className="card-text">
                              Paid Amount: {booking.amount} {booking.currency}
                            </p>
                          )}
                          {booking.payment_status === "completed" && (
                            <p className="card-text">
                              Payment Gateway: {booking.payment_gateway}
                            </p>
                          )}
                        </div>
                      }
                    </p>

                    <p className="card-text mb-0 d-flex justify-content-between mb-0">
                      {
                        <div className="mb-2">
                          <span className="color2 c-badge w98">
                            <i class="bi bi-envelope-fill"></i>{" "}
                          </span>
                          &nbsp; {booking.email}
                        </div>
                      }
                      {
                        <div className="mb-2 statsbx">
                          <span className="color2 c-badge">
                            <i className="bi bi-bell-fill"></i> Booking
                          </span>
                          <span> </span>
                          {booking.status === 1 ? (
                            <span className="badge bg-success">Active</span>
                          ) : booking.status === 2 ? (
                            <span className="badge bg-warning text-dark">
                              Request Reschedule
                            </span>
                          ) : booking.status === 3 ? (
                            <span className="badge bg-primary">
                              Rescheduled
                            </span>
                          ) : booking.status === 4 ? (
                            <span className="badge bg-danger">Cancelled</span>
                          ) : (
                            <span className="nanvalue">_____</span>
                          )}
                        </div>
                      }
                    </p>

                    <p className="card-text mb-0 d-flex justify-content-between mb-1">
                      <div>
                        <span className="color2 c-badge  w98">
                          <i class="bi bi-clock-fill"></i>{" "}
                        </span>
                        &nbsp;{" "}
                        {new Date(booking.booked_at + "Z").toLocaleString(
                          "en-US",
                          {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            timeZoneName: "short",
                          }
                        )}
                      </div>
                    </p>
                    <p className="card-text mb-0 d-flex justify-content-between mb-4">
                      <div className=""></div>
                      <div className=""></div>
                    </p>

                    {/* Details Section */}
                    <Accordion className="mt-3 bdacc">
                      <Accordion.Item eventKey="0">
                        <Accordion.Header>Booking Details</Accordion.Header>
                        <Accordion.Body>
                          {booking.custom_answers &&
                          Object.keys(booking.custom_answers).length > 0 ? (
                            <ul className="list-group">
                              {Object.entries(booking.custom_answers).map(
                                ([question, answer], index) => (
                                  <li key={index} className="list-group-item">
                                    <span className="fw700 fst-italic fs14">
                                      {question}
                                    </span>
                                    <br></br>{" "}
                                    <span className="color2 fs14">
                                      {answer}
                                    </span>
                                  </li>
                                )
                              )}
                            </ul>
                          ) : (
                            <p>No custom answers available.</p>
                          )}
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>

                    <div className="d-flex justify-content-between mt-3">
                      {/* Cancel Button */}
                      {booking.disable_cancelling !== 1 && (
                        <button
                          className="btn btn-danger"
                          onClick={() =>
                            handleCancelBooking(booking.booking_id)
                          }
                        >
                          <i className="bi bi-trash-fill"></i> Cancel
                        </button>
                      )}

                      {/* Edit Dropdown using React-Bootstrap */}
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="secondary"
                          id={`dropdownMenuButton-${booking.booking_id}`}
                        >
                          <i className="bi bi-pencil"></i> Edit
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => handleAddGuests(booking.booking_id)}
                          >
                            <i className="bi bi-person-fill"></i> Add Guests
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() =>
                              handleEditLocation(booking.booking_id)
                            }
                          >
                            <i class="bi bi-geo-alt-fill"></i> Edit Location
                          </Dropdown.Item>

                          {booking.disable_rescheduling !== 1 && (
                            <>
                              <Dropdown.Item
                                onClick={() =>
                                  handleRequestReschedule(booking.booking_id)
                                }
                              >
                                <i className="fas fa-calendar-times"></i>{" "}
                                Request Reschedule
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() =>
                                  handleRescheduleBooking(
                                    booking.booking_id,
                                    booking.event_slug
                                  )
                                }
                              >
                                <i className="fas fa-sync"></i> Reschedule
                              </Dropdown.Item>
                            </>
                          )}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>

                  {/* Action Buttons */}
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {showAddGuestsModal && (
        <AddBookingGuests
          bookingId={selectedBookingId}
          onClose={() => setShowAddGuestsModal(false)}
        />
      )}
      {showEditLocationModal && (
        <EditBookingLocation
          bookingId={selectedBookingId}
          onClose={() => setShowEditLocationModal(false)}
        />
      )}
      <CancelBookingModal
        show={showModal}
        bookingId={bookingId}
        onCancel={cancelBooking}
        onClose={closeModal}
      />
      <RequestReschedule
        show={showRescheduleModal}
        onClose={() => setShowRescheduleModal(false)}
        onSubmit={handleSubmitReschedule}
        reason={rescheduleReason}
        setReason={setRescheduleReason}
      />
    </div>
  );
};

export default UserBookings;
